import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import ApiService from "../util/ApiService";
import Swal from "sweetalert2";

require("./assets/css/Video.css");

const validationSchema = Yup.object({
    name: Yup.string().required('Nome é obrigatório').min(2, 'Nome deve ter pelo menos 2 caracteres')
});

const VideoDepartmentEditModal = ({ show, onHide, department, onSave }) => {
    const [loading, setLoading] = useState(false);

    const initialValues = {
        name: department?.name || '',
        status: department?.status ?? 1
    };

    const handleSubmit = async (values, { setSubmitting }) => {
        try {
            setLoading(true);

            const payload = {
                name: values.name,
                status: values.status
            };

            if (department?.id) {
                payload.id = department.id;
            }

            const response = await ApiService.send(
                "post",
                `${process.env.REACT_APP_URL_API}video/departments/register`,
                payload,
                true
            );

            if (response.code === 200) {
                Swal.fire('Sucesso', department?.id ? 'Departamento atualizado!' : 'Departamento criado!', 'success');
                onSave();
                onHide();
            }
        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoading(false);
            setSubmitting(false);
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    <i className="fa fa-building me-2"></i>
                    {department?.id ? 'Editar Departamento' : 'Novo Departamento'}
                </Modal.Title>
            </Modal.Header>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                enableReinitialize
            >
                {({ errors, touched, isSubmitting, values, setFieldValue }) => (
                    <Form>
                        <Modal.Body>
                            <div className="mb-3">
                                <label className="form-label">Nome do Departamento *</label>
                                <Field
                                    name="name"
                                    type="text"
                                    className={`form-control ${errors.name && touched.name ? 'is-invalid' : ''}`}
                                    placeholder="Ex: Suporte Técnico"
                                />
                                {errors.name && touched.name && (
                                    <div className="invalid-feedback">{errors.name}</div>
                                )}
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Status</label>
                                <div className="form-check form-switch">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="statusSwitch"
                                        checked={values.status === 1}
                                        onChange={(e) => setFieldValue('status', e.target.checked ? 1 : 0)}
                                    />
                                    <label className="form-check-label" htmlFor="statusSwitch">
                                        {values.status === 1 ? 'Ativo' : 'Inativo'}
                                    </label>
                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <button type="button" className="btn btn-secondary" onClick={onHide}>
                                <i className="fa fa-times me-2"></i>
                                Cancelar
                            </button>
                            <button type="submit" className="btn btn-success" disabled={isSubmitting || loading}>
                                {loading ? (
                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                ) : (
                                    <i className="fa fa-check me-2"></i>
                                )}
                                {department?.id ? 'Atualizar' : 'Criar'}
                            </button>
                        </Modal.Footer>
                    </Form>
                )}
            </Formik>
        </Modal>
    );
};

export default VideoDepartmentEditModal;
